import { SkhemataTestimonial } from './src/SkhemataTestimonial.js';

window.customElements.define('skhemata-testimonial', SkhemataTestimonial);
